import { ref, computed, watch } from 'vue'

const cart = ref(JSON.parse(localStorage.getItem('cart')) || [])

export function useCart() {
  // Add to cart
  function addToCart(course) {
    const exists = cart.value.find(item => item.id === course._id)
    if (!exists) {
      cart.value.push({
        id: course._id,
        name: course.title,
        shortSummary: course.shortSummary,
        price: course.price,
        quantity: 1
      })
    }
  }

  // Remove from cart
  function removeFromCart(courseId) {
    cart.value = cart.value.filter(item => item.id !== courseId)
  }

  // Clear cart (optional)
  function clearCart() {
    cart.value = []
  }

  const totalPrice = computed(() =>
    cart.value.reduce((sum, item) => sum + item.price * (item.quantity || 1), 0)
  )

  const cartItemsCount = computed(() =>
    cart.value.reduce((count, item) => count + (item.quantity || 1), 0)
  );

  // Persist to localStorage
  watch(cart, () => {
    localStorage.setItem('cart', JSON.stringify(cart.value))
  }, { deep: true })

  return {
    cart,
    addToCart,
    removeFromCart,
    clearCart,
    cartItemsCount,
    totalPrice
  }
}
